<template>
  <div class="banner">
    <a-icon type="left-circle" @click="nextPrev('prev')" />
    <a-carousel autoplay ref="Carousel">
      <div @click="submit(item)" class="carousel_whole" v-for="(item,index) in bannerList" :key="`${index}-${langKey}`"> <img :src="item.src"> </div>
    </a-carousel>
    <a-icon type="right-circle" @click="nextPrev('next')" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerList: []
    }
  },
  computed: {
    langKey() {
      return this.$store.state.language === 'english' ? 'E' : 'C';
    }
  },
  created() {
    this.setBanner();
  },
  watch: {
    '$store.state.language'() {
      this.setBanner();
    }
  },
  methods: {
    nextPrev(key = null) {
      key && this.$refs.Carousel[key]();
    },
    bannerSrc(name) {
      // 英文版使用 *E.png，中文版沿用原 banner*.png
      const file = this.langKey === 'E' ? `${name}E.png` : `${name}.png`;
      return require(`@/assets/images/banner/${file}`);
    },
    submit({ url = null, router = null, skipKey = null }) {
      let fn = () => {
        router && this.$router.push(router);
        url && this.$router.push({ path: "container", query: { url } });
      };
      if (router == "/standardList/item") {
        skipKey && this.$FN.limitsTips({ list: [skipKey], tips: false }).then(res => res ? fn() : (this.reveal = !res));
      } else {
        skipKey && this.$FN.limitsTips({ list: [skipKey] }).then(res => {
          if (res) fn();
        });
      };
    },
    setBanner() {
      let list = [
        {
          src: this.bannerSrc('banner1'),
          router: "/standardList/item",
          rolesKey: "home_banner_standardList_view",
          skipKey: "home_banner_standardList_skip"
        },
        {
          src: this.bannerSrc('banner2'),
          router: "/digitization",
          rolesKey: "home_banner_digitization_view",
          skipKey: "home_banner_digitization_skip"
        },
        {
          src: this.bannerSrc('banner3'),
          router: "/ceppeaPublish",
          rolesKey: "home_banner_standards_view",
          skipKey: "home_banner_standards_skip"
        },
        {
          src: this.bannerSrc('banner4'),
          router: "/standardTranslation",
          rolesKey: "home_banner_standardTranslation_view",
          skipKey: "home_banner_standardTranslation_skip"
        },
        {
          src: this.bannerSrc('banner5'),
          router: "/technicalRegulations",
          rolesKey: "home_banner_technicalRegulations_view",
          skipKey: "home_banner_technicalRegulations_skip"
        },
        {
          src: this.bannerSrc('banner6'),
          rolesKey: "home_banner_pesData_view"
        },
      ];
      this.bannerList = this.$FN.filterLimitsVisible({ data: list });
    },
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
